import React from 'react';
import { Badge } from './Badge';
interface SectionHeadingProps {
  eyebrow?: string;
  title: React.ReactNode;
  align?: 'left' | 'center';
  className?: string;
  children?: React.ReactNode;
}
export function SectionHeading({
  eyebrow,
  title,
  align = 'center',
  className = '',
  children
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  return <div className={`flex flex-col ${alignment} max-w-3xl ${className}`} data-id="element-16" data-mp="bkvkz0aob30q">
      {eyebrow ? <Badge variant="sky" className="landing-badge mb-4 uppercase tracking-wide" data-id="element-17" data-mp="gi598cmbt8mz">
          {eyebrow}
        </Badge> : null}
      <h2 className="text-3xl font-bold leading-tight text-1a1a2e md:text-4xl lg:text-[2.75rem]" data-id="element-18" data-mp="1sprtn8oqfjy">
        {title}
      </h2>
      {children ? <div className="mt-4 text-lg leading-relaxed text-1a1a2e/70" data-id="element-19" data-mp="uizfopptczj0">{children}</div> : null}
    </div>;
}